import React from "react";

import { useTranslation } from "react-i18next";

import { TooltipHOC, Icon } from "components";

import styles from "./record-counter.module.scss";

interface IRecordCounterProps {
    recordLength: number;
    onClose: () => void;
}

export const RecordCounter: React.FC<IRecordCounterProps> = ({ recordLength, onClose }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.selectedSamplesIndicator}>
            <p className={styles.text}>{t("Selected records: ") + recordLength}</p>
            {!!recordLength && (
                <TooltipHOC
                    tooltipContent={t("Clear")}
                    className={styles.tooltip}
                    onClick={onClose}
                >
                    <Icon name={["far", "circle-xmark"]} />
                </TooltipHOC>
            )}
        </div>
    );
};